/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

// Note: we might remove this change after Oct release
// its been noted that the parent data will take place if the child is missing
// some, but I doubt it about the images though
import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import cloneDeep from "lodash/cloneDeep";

// it currently doesn't appear that we need to memoize this. We may need to later after we resolve some issues with DataState not caching results as well as it could.
export function getComputedVariantProduct(
    parentProductState: ReturnType<typeof getProductStateByPath>,
    variantProductState: ReturnType<typeof getProductState>,
    bomImageName?: string,
) {
    if (!variantProductState.value) {
        return parentProductState;
    }

    if (!parentProductState.value) {
        return parentProductState;
    }

    if (parentProductState.value.id === variantProductState.value.id) {
        return parentProductState;
    }

    const { value: variantProduct } = variantProductState;

    const computedProduct = cloneDeep(parentProductState.value);
    Object.assign(computedProduct, {
        attributeTypes: variantProduct.attributeTypes && variantProduct.attributeTypes.length > 0
            ? variantProduct.attributeTypes
            : parentProductState.value.attributeTypes,
        documents: variantProduct.documents && variantProduct.documents.length > 0
            ? variantProduct.documents
            : parentProductState.value.documents,
        content: variantProduct.content && variantProduct.content.htmlContent
            ? variantProduct.content
            : parentProductState.value.content,
        productNumber: variantProduct.productNumber,
        customerProductNumber: variantProduct.customerProductNumber,
        smallImagePath: variantProduct.images && variantProduct.images?.length === 1 && variantProduct?.images?.[0]?.name === bomImageName ? parentProductState.value.smallImagePath : variantProduct.smallImagePath,
        mediumImagePath: variantProduct.images && variantProduct.images?.length === 1 && variantProduct?.images?.[0]?.name === bomImageName ? parentProductState.value.mediumImagePath : variantProduct.mediumImagePath,
        largeImagePath: variantProduct.images && variantProduct.images?.length === 1 && variantProduct?.images?.[0]?.name === bomImageName ? parentProductState.value.largeImagePath : variantProduct.largeImagePath,
        imageAltText: variantProduct.imageAltText,
        id: variantProduct.id,
        quoteRequired: variantProduct.quoteRequired,
        productTitle: variantProduct.productTitle,
        images: (variantProduct.images && variantProduct.images?.length > 0)
        ? variantProduct.images
        : parentProductState.value.images,
        trackInventory: variantProduct.trackInventory,
        minimumOrderQty: variantProduct.minimumOrderQty,
        canonicalUrl: variantProduct.canonicalUrl,
        unitOfMeasures: variantProduct.unitOfMeasures,
        isVariantParent: false,
        canAddToWishlist: variantProduct.canAddToWishlist,
        cantBuy: variantProduct.cantBuy,
        allowZeroPricing: variantProduct.allowZeroPricing,
        manufacturerItem: variantProduct.manufacturerItem,
        detail: variantProduct.detail,
        properties: {
            ...variantProduct.properties,
            jettingCalculatorId: computedProduct.properties?.jettingCalculatorId,
            jettingCalculatorFamily: computedProduct.properties?.jettingCalculatorFamily,
            jettingCalculatorTool: computedProduct.productNumber,
        },
    });

    return {
        isLoading: parentProductState.isLoading,
        id: variantProductState.id,
        value: computedProduct,
    };
}